"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerLightscriptNodeTypes = registerLightscriptNodeTypes;
function registerLightscriptNodeTypes(t) {
  var definePluginType = t.definePluginType,
      assertNodeType = t.assertNodeType,
      assertValueType = t.assertValueType,
      assertOneOf = t.assertOneOf,
      assertEach = t.assertEach,
      chain = t.chain;


  if (!t.hasType("ForInArrayStatement")) {
    definePluginType("ForInArrayStatement", {
      visitor: ["idx", "elem", "array", "body"],
      aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop", "ForXStatement", "ForIn"],
      fields: {
        elem: {
          validate: assertNodeType("Identifier"),
          optional: true
        },
        idx: {
          validate: assertNodeType("Identifier"),
          optional: true
        },
        array: {
          validate: assertNodeType("Expression")
        },
        body: {
          validate: assertNodeType("Statement")
        }
      }
    });
  }if (!t.hasType("ForInObjectStatement")) {
    definePluginType("ForInObjectStatement", {
      visitor: ["key", "val", "object", "body"],
      aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop", "ForXStatement", "ForIn"],
      fields: {
        key: {
          validate: assertNodeType("Identifier"),
          optional: true
        },
        val: {
          validate: assertNodeType("Identifier"),
          optional: true
        },
        object: {
          validate: assertNodeType("Expression")
        },
        body: {
          validate: assertNodeType("Statement")
        }
      }
    });
  }if (!t.hasType("SpreadLoop")) {
    definePluginType("SpreadLoop", {
      builder: ["loop"],
      visitor: ["loop"],
      aliases: ["Expression"],
      fields: {
        loop: {
          validate: assertNodeType("ForStatement")
        }
      }
    });
  }if (!t.hasType("NamedArrowDeclaration")) {
    definePluginType("NamedArrowDeclaration", {
      builder: ["id", "params", "body", "skinny", "async", "generator"],
      visitor: ["id", "params", "body", "returnType", "typeParameters"],
      aliases: ["Scopable", "Function", "BlockParent", "FunctionParent", "Statement", "Pureish", "Declaration", "FunctionDeclaration", "NamedArrowFunction"],
      fields: { // DUP in NamedArrowMemberExpression
        id: {
          validate: assertNodeType("Identifier")
        },
        params: {
          validate: chain(assertValueType("array"), assertEach(assertNodeType("LVal")))
        },
        body: {
          validate: assertNodeType("BlockStatement", "Expression")
        },
        skinny: {
          validate: assertValueType("boolean")
        },
        generator: {
          default: false,
          validate: assertValueType("boolean")
        },
        async: {
          default: false,
          validate: assertValueType("boolean")
        }
      }
    });
  }if (!t.hasType("NamedArrowExpression")) {
    definePluginType("NamedArrowExpression", {
      inherits: "NamedArrowDeclaration",
      aliases: ["Scopable", "Function", "FunctionExpression", "BlockParent", "FunctionParent", "Expression", "Pureish", "NamedArrowFunction"]
    });
  }if (!t.hasType("NamedArrowMemberExpression")) {
    definePluginType("NamedArrowMemberExpression", {
      inherits: "NamedArrowExpression",
      fields: { // c/p from NamedArrowExpression except for `object`
        id: {
          validate: assertNodeType("Identifier")
        },
        object: {
          validate: assertNodeType("Identifier", "MemberExpression")
        },
        params: {
          validate: chain(assertValueType("array"), assertEach(assertNodeType("LVal")))
        },
        body: {
          validate: assertNodeType("BlockStatement", "Expression")
        },
        skinny: {
          validate: assertValueType("boolean")
        },
        generator: {
          default: false,
          validate: assertValueType("boolean")
        },
        async: {
          default: false,
          validate: assertValueType("boolean")
        }
      }
    });
  }if (!t.hasType("IfExpression")) {
    definePluginType("IfExpression", {
      visitor: ["test", "consequent", "alternate"],
      aliases: ["Expression", "Conditional"],
      fields: {
        test: {
          validate: assertNodeType("Expression")
        },
        consequent: {
          validate: assertNodeType("Expression", "BlockStatement", "ExpressionStatement")
        },
        alternate: {
          optional: true,
          validate: assertNodeType("Expression", "BlockStatement", "ExpressionStatement")
        }
      }
    });
  }if (!t.hasType("SafeAwaitExpression")) {
    definePluginType("SafeAwaitExpression", {
      builder: ["argument"],
      visitor: ["argument"],
      aliases: ["AwaitExpression", "Expression", "Terminatorless"],
      fields: {
        argument: {
          validate: assertNodeType("Expression")
        }
      }
    });
  }if (!t.hasType("ExistentialExpression")) {
    definePluginType("ExistentialExpression", {
      builder: ["argument"],
      visitor: ["argument"],
      aliases: ["Expression"],
      fields: {
        argument: {
          validate: assertNodeType("Expression")
        }
      }
    });
  }if (!t.hasType("MatchExpression")) {
    definePluginType("MatchExpression", {
      builder: ["discriminant", "cases"],
      visitor: ["discriminant", "cases"],
      aliases: ["Expression", "Conditional"],
      fields: {
        discriminant: {
          validate: assertNodeType("Expression")
        },
        cases: {
          validate: chain(assertValueType("array"), assertEach(assertNodeType("MatchCase")))
        }
      }
    });
  }if (!t.hasType("MatchStatement")) {
    definePluginType("MatchStatement", {
      builder: ["discriminant", "cases"],
      visitor: ["discriminant", "cases"],
      aliases: ["Statement", "Conditional"],
      fields: {
        discriminant: {
          validate: assertNodeType("Expression")
        },
        cases: {
          validate: chain(assertValueType("array"), assertEach(assertNodeType("MatchCase")))
        }
      }
    });
  }if (!t.hasType("MatchCase")) {
    definePluginType("MatchCase", {
      builder: ["outerGuard", "atoms", "binding", "assertive", "innerGuard", "consequent"],
      visitor: ["test", "outerGuard", "atoms", "binding", "innerGuard", "consequent"],
      fields: {
        // XXX: v3 compatibility, remove when syntax settles
        test: {
          validate: assertNodeType("Expression", "MatchElse"),
          optional: true
        },
        outerGuard: {
          validate: assertNodeType("Expression", "MatchElse"),
          optional: true
        },
        atoms: {
          validate: chain(assertValueType("array"), assertEach(assertNodeType("Expression"))),
          optional: true
        },
        binding: {
          validate: assertNodeType("ArrayPattern", "ObjectPattern"),
          optional: true
        },
        assertive: {
          validate: assertValueType("boolean"),
          optional: true
        },
        innerGuard: {
          validate: assertNodeType("Expression"),
          optional: true
        },
        consequent: {
          validate: assertNodeType("Expression", "Statement")
        }
      }
    });
  }if (!t.hasType("MatchElse")) {
    definePluginType("MatchElse", {});
  }if (!t.hasType("MatchPlaceholderExpression")) {
    definePluginType("MatchPlaceholderExpression", {
      aliases: ["Expression"]
    });
  }if (!t.hasType("PlaceholderExpression")) {
    definePluginType("PlaceholderExpression", {
      aliases: ["Expression"]
    });
  }if (!t.hasType("PipeCallExpression")) {
    definePluginType("PipeCallExpression", {
      visitor: ["left", "right"],
      aliases: ["CallExpression", "Expression"],
      fields: {
        left: {
          validate: assertNodeType("Expression")
        },
        right: {
          validate: assertNodeType("Expression")
        }
      }
    });
  }
}


//////////////////
// WEBPACK FOOTER
// ../~/@oigroup/babel-plugin-lightscript/lib/lscNodeTypes.js
// module id = 827
// module chunks = 0